import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { VectorGreen } from '@/shared/images/icons/VectorGreen';

export const VActivitySubtitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 0 0 17px;

    ${Screen.ipad} {
        gap: 16px;
    }

    ${Screen.desktop} {
        gap: 20px;
    }
`;

export const VLeftSection = styled.div`
    display: flex;
    gap: 12px;
`;

export const VLocation = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    ${Text.Full.large.medium};
    color: ${cssVars.fg_gray2_gray3};

    ${Screen.ipad} {
        ${Text.Ipad.large.medium};
    }
`;

export const VLocationIcon = styled(VectorGreen)`
    display: flex;
    height: auto;
    ${Screen.desktop} {
        height: 15px;
        width: 13px;
    }
`;
